document.addEventListener("DOMContentLoaded", () => {
    const getCountry = function (str) {
        return str.replace(/[^A-Z]+/g, "");
    };

    const docLanguage = document.documentElement.lang;
    const country = getCountry(docLanguage);

    const isCH = country === "CH";
    const isDE = country === "DE";

    if (!isCH && !isDE) return;

    const form = document.querySelector("#formclient");

    window.addEventListener("FormClientRendered", function () {
        let mobileProvided = false;
        form.addEventListener("submit", function (event) {
            if (!mobileProvided) {
                const leadData = event.detail.leadData;

                if (leadData.Phone) {
                    const isMobile = window.libphonenumber.parsePhoneNumberFromString(leadData.Phone, country).getType() == "MOBILE";
                    const pushKey = form.dataset.id + "-" + (form.dataset.offerType ? form.dataset.offerType : "generic");

                    isMobile &&
                        window.sessionLayer.leadHandler.push(pushKey, {
                            MobilePhone: leadData.Phone,
                        });
                    mobileProvided = true;
                }
            }
        });
    });
});
